export default "__VITE_ASSET__De5Fv2Gx__"